import type { HistoryStyle, PassageHistoryEntry, PassageThreadState } from "./types";
import { element as node } from "./dom";
/** Stateless semantic visual primitives. No Org parsing or navigation handlers. */
export const Title = (text: string) => node("h1", "ss-title", text);
export const Quote = (text: string, attribution = "") => {
  const result = node("blockquote", "ss-quote", text);
  if (attribution) result.append(node("cite", "", attribution));
  return result;
};
export const Callout = (text: string) => node("aside", "ss-callout", text);
export const Metric = (value: string, label: string, delta = "") => {
  const result = node("div", "ss-metric", "");
  result.append(node("strong", "", value), node("span", "", label));
  if (delta) result.append(node("small", "", delta));
  return result;
};
export const Image = (src: string, alt: string) => {
  const result = node("img", "ss-image", ""); result.src = src; result.alt = alt; return result;
};
export const LowerThird = (text: string) => node("aside", "ss-lower-third", text);
export const Scripture = (reference: string, text = "") => {
  const result = node("section", "ss-scripture", "");
  result.append(node("strong", "ss-passage-current", reference));
  if (text) result.append(Quote(text));
  return result;
};
export const ProgressRail = (current: number, total: number) => {
  const result = node("progress", "ss-progress-rail", "");
  result.max = Math.max(1, total); result.value = current;
  result.setAttribute("aria-label", "Progress"); return result;
};
export function PassageHistory(history: PassageHistoryEntry[], style: HistoryStyle) {
  const rail = node("nav", "ss-history ss-history-" + style, "");
  rail.setAttribute("aria-label", "Previously shown passages");
  rail.hidden = style === "none" || history.length === 0;
  rail.append(node("span", "", "Previously: "));
  const list = node("ol", "", "");
  for (const item of history) list.append(node("li", "", item.reference));
  rail.append(list); return rail;
}
export function PassageThread(thread: PassageThreadState, hideFuture = false) {
  const rail = node("nav", "ss-thread", ""); rail.setAttribute("aria-label", thread.label);
  rail.append(node("strong", "", thread.label));
  for (const passage of thread.completed) rail.append(node("span", "is-complete", "✓ " + passage));
  const current = node("span", "is-current", "→ " + thread.current);
  current.setAttribute("aria-current", "step"); rail.append(current);
  if (!hideFuture) for (const passage of thread.future) rail.append(node("span", "is-future", passage));
  return rail;
}
